import { useMutation } from "react-query";
import { getInvoiceBy } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useSearchCompleted = () => {
  return useMutation(getInvoiceBy);
};
export default useSearchCompleted;
